import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import translationEN from './locales/en/translation.json';
import translationID from './locales/id/translation.json';
import translationZH from './locales/zh/translation.json';

const supportedLngs = ['en', 'id', 'zh'];
const savedLanguage = typeof window !== 'undefined' ? localStorage.getItem('i18nextLng') : null;

const resources = {
  en: {
    translation: translationEN,
  },
  id: {
    translation: translationID,
  },
  zh: {
    translation: translationZH,
  },
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: savedLanguage && supportedLngs.includes(savedLanguage) ? savedLanguage : 'en',
    supportedLngs,
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false, // react already safes from xss
    },
  });

i18n.on('languageChanged', (lng) => {
  if (typeof window !== 'undefined') {
    localStorage.setItem('i18nextLng', lng);
    document.documentElement.lang = lng;
  }
});

export default i18n;
